import React from "react";

const Settings = () => {
  return (
    <div className="d-flex justify-content-center fs-1 fw-bold">Settings</div>
  );
};

export default Settings;
